import { render, staticRenderFns } from "./SensorEvents.vue?vue&type=template&id=0dc3fa2c&scoped=true&"
import script from "./SensorEvents.vue?vue&type=script&lang=js&"
export * from "./SensorEvents.vue?vue&type=script&lang=js&"
import style0 from "./SensorEvents.vue?vue&type=style&index=0&id=0dc3fa2c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc3fa2c",
  null
  
)

/* custom blocks */
import block0 from "./SensorEvents.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dc3fa2c')) {
      api.createRecord('0dc3fa2c', component.options)
    } else {
      api.reload('0dc3fa2c', component.options)
    }
    module.hot.accept("./SensorEvents.vue?vue&type=template&id=0dc3fa2c&scoped=true&", function () {
      api.rerender('0dc3fa2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/Activity/SensorEvents/SensorEvents.vue"
export default component.exports